import { render, staticRenderFns } from "./CountryChips.vue?vue&type=template&id=d26cdbf0&scoped=true&"
import script from "./CountryChips.vue?vue&type=script&lang=js&"
export * from "./CountryChips.vue?vue&type=script&lang=js&"
import style0 from "./CountryChips.vue?vue&type=style&index=0&id=d26cdbf0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26cdbf0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VAvatar,VChip})
